"use strict";
var $dyn;
(function ($dyn) {
    // tslint:disable-next-line:variable-name
    $dyn._cachedRoleExpression = {};
    /**
     * Get the role context associated with the target element.
     */
    function roleContext(targetElement) {
        // Check to see if there is a role attribute specified
        var roleExpression = targetElement.getAttribute($dyn.Const.roleAttribute);
        // tslint:disable-next-line:no-shadowed-variable
        var roleContext;
        if (roleExpression) {
            // Evaluate the role expression
            if ($dyn._cachedRoleExpression[roleExpression]) {
                roleContext = $dyn._cachedRoleExpression[roleExpression];
            }
            else {
                var ending = roleExpression[roleExpression.length - 1];
                // Fast detect that it is string rather than an expression
                if (ending === "'" || ending === "}" || ending === '"') {
                    roleContext = (new Function(" return {" + roleExpression + "}; ")).call(null);
                }
                else {
                    roleContext = { Control: roleExpression };
                }
                $dyn._cachedRoleExpression[roleExpression] = roleContext;
            }
        }
        return roleContext;
    }
    $dyn.roleContext = roleContext;
    /**
     * Get the role type associated with the target element.
     */
    function roleType(targetElement) {
        // tslint:disable-next-line:no-shadowed-variable
        var roleContext = $dyn.roleContext(targetElement);
        if (roleContext.Control.type) {
            return roleContext.Control.type;
        }
        else {
            return roleContext.Control;
        }
    }
    $dyn.roleType = roleType;
    /**
     * Get the role associated with the target element.
     */
    function role(targetElement) {
        if (!targetElement) {
            throw new Error("Argument 'targetElement' must be a non-null html element");
        }
        // Check if the element already has a role associated
        var roleInstance = targetElement[$dyn.Const.roleInstance];
        /// #DEBUG
        if ($dyn.Const.roleInstance in targetElement && roleInstance === undefined) {
            // Calling $dyn.role will create a new role instance on the dom element, the dom element is in a unknown state
            $dyn.logWarning("Framework: $dyn.role called on a disposed element");
        }
        /// #ENDDEBUG
        if (!roleInstance) {
            // Check to see if there is a role attribute specified
            var roleName = targetElement.getAttribute($dyn.Const.roleAttribute);
            if (roleName) {
                // Use the role handler's factory method
                roleInstance = new $dyn.roleHandlers.Control(targetElement, roleName);
            }
            if (!roleInstance) {
                // Create the role using the default handler
                roleInstance = new $dyn.roleHandlers.Default(targetElement);
            }
            targetElement[$dyn.Const.roleInstance] = roleInstance;
        }
        return roleInstance;
    }
    $dyn.role = role;
    /**
     * Binds an element to a given $dyn.DataContext
     * @param targetElement The element to bind
     * @param dataContext The data context to bind to the element
     * @param onDataBindComplete The callback for when the binding is complete
     */
    function dataBind(targetElement, dataContext, onDataBindComplete) {
        $dyn.role(targetElement).dataBind(dataContext, onDataBindComplete);
    }
    $dyn.dataBind = dataBind;
    /**
     * Unbinds an element if it has been previously bound.
     * @param targetElement The element to unbind.
     */
    function unbind(targetElement) {
        // Dispose the role instance associated with this element
        if (targetElement) {
            // tslint:disable-next-line:no-shadowed-variable
            var role_1 = targetElement[$dyn.Const.roleInstance];
            if (role_1) {
                role_1.dispose();
                targetElement[$dyn.Const.roleInstance] = undefined;
            }
        }
    }
    $dyn.unbind = unbind;
    /**
     * Check if an element is unbound.
     * @description An element is unbound if it doesn't have a role object.
     * @param targetElement The element to to check.
     */
    function isUnbound(targetElement) {
        return !targetElement || !targetElement[$dyn.Const.roleInstance];
    }
    $dyn.isUnbound = isUnbound;
    /**
     * Role handlers are responsible for binding an element to an instance of the control they represent.
     * @description The role handlers are registered in the system under the $dyn.roleHandlers namespace
     * Each role handler must be a function that takes following parameters:<br>
     * 'targetElement' - the element on which the role is being allowed<br>
     * 'roleOptions' - the options provided for initializing the role<br>
     * Role handler function must return an instance of the role with a required prototype.
     * It is recommended that roleHandlers extend the base html role handler in order to
     * get all the basic functionalities of a role.
     */
    var roleHandlers;
    (function (roleHandlers) {
        /**
         * The base html role handler constructor
         * @description Base html handler handles any HTML DOM node
         */
        var Html = /** @class */ (function () {
            function Html(targetElement) {
                this.targetElement = targetElement;
                this.shouldDataBindChildren = false;
                this.childrenDataBound = false;
                this.disposed = false;
                this._isDataBound = false;
                this.type = "Html";
                if ($dyn.debug.performance) {
                    this._dataBindingTask = new $dyn.DomPerformanceTask("dataBinding");
                    this._dataBindingChildrenTask = new $dyn.DomPerformanceTask("dataBindingChildren");
                    this._bindingCreatedTask = new $dyn.DomPerformanceTask("bindingCreated");
                    this._bindingUpdatedTask = new $dyn.DomPerformanceTask("bindingUpdated");
                    this._bindingValueUpdatedTask = new $dyn.DomPerformanceTask("bindingValueUpdated");
                }
            }
            /**
             * Gets the handlers for a specific binding type.
             */
            Html.prototype.getHandlerClass = function (bindingType) {
                return $dyn.bindingHandlers[bindingType];
            };
            /**
             * Gets the binding handler instance for this role given a binding type
             */
            Html.prototype.getHandler = function (bindingType) {
                if (!this._handlers) {
                    this._handlers = {};
                }
                var handler = this._handlers[bindingType];
                if (!handler) {
                    // Create the binding handler for the first time
                    var handlerClass = $dyn.bindingHandlers[bindingType];
                    if (handlerClass) {
                        // Create the handler instance for this element
                        if (typeof handlerClass === "function") {
                            handler = handlerClass(this.targetElement, this);
                            this._handlers[bindingType] = handler;
                        }
                        else {
                            this._handlers[bindingType] = handler = handlerClass;
                        }
                    }
                    else {
                        // Invalid binding type, add to the dictionary so we don't try to create again
                        $dyn.logError("Unknown binding type: %s, element: %o", bindingType, this.targetElement);
                        if ($dyn.debug.bindingErrorAsMessages) {
                            // tslint:disable-next-line:no-shadowed-variable
                            var role_2 = this.targetElement.getAttribute("data-dyn-role");
                            var warning = void 0;
                            if (role_2) {
                                warning = $dyn.format("Unknown binding type: {0}, role: {1}", bindingType, this.targetElement.getAttribute("data-dyn-role"));
                                $dyn.warn({ Message: warning, Label: warning });
                            }
                            else {
                                warning = $dyn.format("Unknown binding type: {0}", bindingType);
                                $dyn.warn({ Message: warning, Label: warning });
                            }
                        }
                    }
                }
                return handler;
            };
            /**
             * Evaluates the data-context of the role element based on the given parent data-context.
             * @description Base implementation doesn't unwrap the parent data-context if that is an observable.
             */
            Html.prototype.evalDataContext = function (parentData, virtualInstance) {
                return $dyn.evalDataContext(this.targetElement, parentData, "data-dyn-context");
            };
            /**
             * Gets whether the element has data-binding specified on it that needs to be evaluated and applied
             */
            Html.prototype.hasBinding = function () {
                return $dyn.hasDataBinding(this.targetElement);
            };
            /**
             * @deprecated
             */
            Html.prototype.applyBinding = function (binding, dataContext, virutalInstance) {
                // Deprecated - should be removed since owa adapter is removed
                if (binding) {
                    // tslint:disable-next-line:forin
                    for (var bindingType in binding) {
                        var bindingData = binding[bindingType];
                        this.applyHandler(bindingType, bindingData, dataContext);
                    }
                }
            };
            /**
             * Applies a handler to a binding.
             * @param bindingType The binding key name of the handler for the binding. Typically represents abstract html concepts such as text or value
             *                    but can also be used for control flow such as with the if and foreach binding handlers.
             * @param bindingData The value of the binding.
             * @param dataContext The current data context.
             */
            Html.prototype.applyHandler = function (bindingType, bindingData, dataContext) {
                var _this = this;
                // Get the handler
                var handler = this.getHandler(bindingType);
                // apply the data through the handler
                if (handler) {
                    // The value of the binding data is observed so any change to it is reapplied
                    var firstTime_1 = true;
                    var handlerObserver = $dyn.observe(function () {
                        return $dyn.value(bindingData);
                    }, function (bindingValue) {
                        var unwrappedContext = $dyn.contextValue(dataContext);
                        if (unwrappedContext && unwrappedContext.bindingTrigger) {
                            return;
                        }
                        if (!firstTime_1) {
                            _this._bindingValueUpdatedTask && _this._bindingValueUpdatedTask.start(_this.targetElement, bindingType);
                        }
                        if ($dyn.debug.verboseBinding) {
                            $dyn.log("[html-binding] Binding: %s, Value: %o, Role: %o, Element: %o", bindingType, bindingValue, _this, _this.targetElement);
                        }
                        if (handler.apply) {
                            // old-style handler
                            handler.apply(bindingValue, dataContext, bindingData);
                        }
                        else {
                            // new-style handler
                            $dyn._invokeHandler(bindingType, _this.targetElement, bindingData, $dyn.value(_this.context.current));
                        }
                        if (!firstTime_1) {
                            _this._bindingValueUpdatedTask && _this._bindingValueUpdatedTask.stop(_this.targetElement, bindingType);
                        }
                        else {
                            firstTime_1 = false;
                        }
                    });
                    handlerObserver.__name = "applyHandler";
                    if ($dyn.debug.general) {
                        handlerObserver.__name += "_" + bindingType;
                    }
                }
            };
            /**
             * Propagates the binding down the hierarchy of the current instance
             */
            Html.prototype.dataBindChildren = function (dataContext, virtualInstance, forceBinding) {
                if (forceBinding === void 0) { forceBinding = false; }
                if (this.shouldDataBindChildren) {
                    if (!this.childrenDataBound || forceBinding) {
                        var children_1 = this.targetElement.children;
                        if (children_1) {
                            for (var i = 0, len = children_1.length; i < len; i++) {
                                var child = children_1[i];
                                // Current data context propagates to descendants
                                if (child && !child.hasAttribute($dyn.Const.stopBindingAttribute)) {
                                    this.dataBindChild(child, dataContext, virtualInstance);
                                }
                            }
                        }
                        if (dataContext && dataContext.current && dataContext.current.postDataBindChildren) {
                            dataContext.current.postDataBindChildren();
                        }
                        this.childrenDataBound = true;
                    }
                }
            };
            Html.prototype.dataBindItem = function (itemElement, dataContext, virtualInstance) {
                this.shadowedContext = dataContext && dataContext.parentContext;
                this.getChildRole(itemElement).dataBind(dataContext, null, virtualInstance, this.shadowedContext);
            };
            Html.prototype.dataBindChild = function (itemElement, dataContext, virtualInstance) {
                if (this.shouldDataBindChildren) {
                    // The dom node is a template child
                    var templatedParent = itemElement.dynTemplatedParent;
                    var childRole = void 0;
                    if (templatedParent) {
                        // TODO: How can the target element be same a the parent?
                        // tslint:disable-next-line:no-shadowed-variable
                        var role_3 = templatedParent === this.targetElement ? this : $dyn.role(templatedParent);
                        var templatedParentDataContext = role_3.context;
                        if (templatedParentDataContext) {
                            // Should it be just templatedParentDataContext and have Control override dataBindChild?
                            // scopeVars._dataSourceContext is a Control specific concept
                            childRole = role_3.getChildRole(itemElement);
                            if (!childRole.context) {
                                childRole.dataBind(templatedParentDataContext.scopeVars._dataSourceContext, null, virtualInstance, dataContext);
                            }
                        }
                    }
                    else {
                        childRole = this.getChildRole(itemElement);
                        if (!childRole.context) {
                            childRole.dataBind(dataContext, null, virtualInstance, this.shadowedContext);
                        }
                    }
                }
            };
            Html.prototype.getChildRole = function (itemElement) {
                return $dyn.role(itemElement);
            };
            Html.prototype.expandTemplate = function () {
                var _this = this;
                var templateExpression = this.targetElement.getAttribute($dyn.Const.templateAttribute);
                var templateApplied = this.targetElement.getAttribute($dyn.Const.templateApplied);
                if (templateExpression && !templateApplied) {
                    $dyn.loadTemplateInstance(templateExpression, function (templateInstance) {
                        _this.targetElement.setAttribute($dyn.Const.templateApplied, true);
                        var children = $dyn.getBindableChildren(_this.targetElement);
                        for (var i = 0, len = children.length; i < len; i++) {
                            var child = children[i];
                            _this.getChildRole(child).expandTemplate();
                        }
                    }, this.targetElement);
                }
                else {
                    var children_2 = $dyn.getBindableChildren(this.targetElement);
                    for (var i = 0, len = children_2.length; i < len; i++) {
                        var child = children_2[i];
                        this.getChildRole(child).expandTemplate();
                    }
                }
            };
            /**
             * Performs data-binding on the role.
             * @description Performs data-binding on the role. Optionally it can data-bind on a virtualized instance of the role.
             * The base html role functionality doesn't do virtualized binding and ignores the virtualInstance.
             * However, the derived roles may extend this functionality.
             */
            Html.prototype.dataBind = function (dataContext, onDataBindComplete, virtualInstance, shadowedContext) {
                var _this = this;
                // Check if the data-template is specified, in which case that will replace the content of this node's children
                // This happens only once on the very first data-bind
                var templateExpression = this.targetElement.getAttribute($dyn.Const.templateAttribute);
                var templateApplied = this.targetElement.getAttribute($dyn.Const.templateApplied);
                this.shadowedContext = shadowedContext;
                if (templateExpression && !templateApplied) {
                    $dyn.loadTemplateInstance(templateExpression, function (templateInstance) {
                        _this.targetElement.setAttribute($dyn.Const.templateApplied, true);
                        _this.doDataBinding(dataContext, virtualInstance);
                        if (onDataBindComplete) {
                            onDataBindComplete();
                        }
                    }, this.targetElement);
                }
                else {
                    this.doDataBinding(dataContext, virtualInstance);
                    if (onDataBindComplete) {
                        onDataBindComplete();
                    }
                }
            };
            /**
             * Allows data binding after required resources have been loaded.
             * @description The do data-bind method is to allow us to process binding in this part of the DOM tree
             * only after the required resources for this has been loaded
             */
            Html.prototype.doDataBinding = function (dataContext, virtualInstance) {
                var _this = this;
                this._dataBindingTask && this._dataBindingTask.start(this.targetElement);
                if ($dyn.debug.general) {
                    if (this.context) {
                        $dyn.logError("Rebind called: %o", this);
                        return;
                    }
                }
                this.shouldDataBindChildren = true;
                // Get the element's data-context, either inherited or redefined
                this.context = this.targetElement.dynContext = this.evalDataContext(dataContext, virtualInstance);
                // Process any binding expression that is specified on the element
                if (this.hasBinding()) {
                    var unwrappedContext_1 = $dyn.contextValue(this.context);
                    // If a bindingTrigger is specified then simply apply the handlers without any computed scopes.
                    if (unwrappedContext_1 && unwrappedContext_1.bindingTrigger) {
                        $dyn.observe(unwrappedContext_1.bindingTrigger, function () {
                            var evaluator = $dyn.getBasicBindings(_this.targetElement);
                            if (evaluator) {
                                var bindings = evaluator(_this.context.current, _this.targetElement);
                                // tslint:disable-next-line:forin
                                for (var handlerName in bindings) {
                                    var bindingData = bindings[handlerName];
                                    $dyn._invokeHandler(handlerName, _this.targetElement, bindingData, unwrappedContext_1);
                                }
                            }
                        });
                    }
                    else {
                        var bindingSet = this._getBindings();
                        if (bindingSet) {
                            for (var i = 0, len = bindingSet.length; i < len; i++) {
                                var binding = bindingSet[i];
                                // tslint:disable-next-line:forin
                                for (var handlerName in binding) {
                                    this._handleBinding(handlerName, binding[handlerName], this.context, virtualInstance);
                                }
                            }
                        }
                    }
                }
                this._dataBindingTask && this._dataBindingTask.stop(this.targetElement);
                this._dataBindingChildrenTask && this._dataBindingChildrenTask.start(this.targetElement);
                // Process children
                this.dataBindChildren(this.context, virtualInstance, false);
                if (this.childrenDataBound) {
                    this._setDataBound();
                }
                this._dataBindingChildrenTask && this._dataBindingChildrenTask.stop(this.targetElement);
            };
            Html.prototype.dispose = function () {
                var _this = this;
                this.disposed = true;
                if (this._handlers) {
                    // Dispose all handlers
                    $.each(this._handlers, function (handlerName, handler) {
                        if (handler.dispose) {
                            handler.dispose(_this.targetElement, _this.targetElement && _this.targetElement.dynStates ? _this.targetElement.dynStates[handlerName] : undefined, _this.targetElement && _this.targetElement.dynLastHandlerValue ? _this.targetElement.dynLastHandlerValue[handlerName] : undefined);
                            if (_this.targetElement && _this.targetElement.dynHandlersExecuted && _this.targetElement.dynHandlersExecuted[handlerName]) {
                                // prevent dispose getting called twice for one handler
                                delete _this.targetElement.dynHandlersExecuted[handlerName];
                            }
                        }
                    });
                }
                this._handlers = undefined;
                if (this._bindings) {
                    // Dispose all bindings
                    $.each(this._bindings, function (handlerName, binding) {
                        if (binding.dispose) {
                            binding.dispose();
                        }
                    });
                }
                this._bindings = undefined;
                if (this.targetElement) {
                    if (this.targetElement.dynHandlersExecuted) {
                        // Depending on if it is BindingHandlerV1 or V2 it could be on the dynHandlersExecuted but not in the _handlers object
                        // tslint:disable-next-line:forin
                        for (var handlerName in this.targetElement.dynHandlersExecuted) {
                            var handler = $dyn.bindingHandlers[handlerName];
                            if (handler && handler.dispose) {
                                handler.dispose(this.targetElement, this.targetElement.dynStates ? this.targetElement.dynStates[handlerName] : undefined, this.targetElement.dynLastHandlerValue ? this.targetElement.dynLastHandlerValue[handlerName] : undefined);
                            }
                        }
                        this.targetElement.dynHandlersExecuted = null;
                    }
                    if (this.targetElement.dynStates) {
                        this.targetElement.dynStates = null;
                    }
                    if (this.targetElement.dynLastHandlerValue) {
                        this.targetElement.dynLastHandlerValue = null;
                    }
                    if (this.targetElement.dynBasicBindings) {
                        this.targetElement.dynBasicBindings = null;
                    }
                }
                // Optimize to not unbind unbound children
                if (this.shouldDataBindChildren) {
                    if (this.childrenDataBound) {
                        var children_3 = this.targetElement.children;
                        if (children_3) {
                            for (var i = 0, len = children_3.length; i < len; i++) {
                                var child = children_3[i];
                                // If the stop databinding attribute is present then the role handler should be responsible for unbinding
                                if (child && !child.hasAttribute($dyn.Const.stopBindingAttribute)) {
                                    $dyn.unbind(child);
                                }
                            }
                        }
                    }
                }
                if (this.targetElement.dynContext) {
                    this.targetElement.dynContext = null;
                }
                if (this.targetElement.dynContent) {
                    if (this.targetElement.dynContent.dispose) {
                        this.targetElement.dynContent.dispose();
                    }
                    this.targetElement.dynContent = null;
                }
            };
            /**
             * Gets the last applied data-context to this role
             */
            Html.prototype.dataContext = function () {
                return this.context;
            };
            /**
             * Get the non-observable databound state
             */
            Html.prototype._getIsDataBound = function () {
                if (this.__isDataBound) {
                    return $dyn.peek(this.__isDataBound);
                }
                return this._isDataBound;
            };
            Html.prototype._setDataBound = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (this.__isDataBound) {
                    this.__isDataBound(true);
                }
                this._isDataBound = true;
            };
            Object.defineProperty(Html.prototype, "isDataBound", {
                /**
                 * Get the observable databound state
                 */
                get: function () {
                    if (!this.__isDataBound) {
                        this.__isDataBound = $dyn.observable(this._isDataBound);
                    }
                    return this.__isDataBound;
                },
                enumerable: false,
                configurable: true
            });
            Html.prototype._getBindings = function (dataContext) {
                return $dyn.getBindings(this.targetElement, dataContext);
            };
            Html.prototype._handleBinding = function (handlerName, evaluator, dataContext, virtualInstance) {
                var _this = this;
                if (evaluator) {
                    // The binding expression evaluation is observed so any dependency change at the
                    // expression level is auto-tracked
                    var firstTime_2 = true;
                    var bindingObserver = $dyn.observe(
                    // The observing logic is to evaluate the binding expression
                    function () {
                        return evaluator(dataContext, _this.targetElement);
                    }, function (binding) {
                        if (binding) {
                            if (firstTime_2) {
                                _this._bindingCreatedTask && _this._bindingCreatedTask.start(_this.targetElement, handlerName);
                            }
                            else {
                                _this._bindingUpdatedTask && _this._bindingUpdatedTask.start(_this.targetElement, handlerName);
                            }
                            if ($dyn.debug.general) {
                                _this._lastBindingsApplied = _this._lastBindingsApplied || {};
                                // TODO: The evaluator currently returns the binding as
                                // a key/value pair, but the evaluator can be changed to
                                // just return the value.
                                _this._lastBindingsApplied[handlerName] = binding[handlerName];
                            }
                            // Apply the binding
                            _this.applyBinding(binding, dataContext, virtualInstance);
                            if (firstTime_2) {
                                _this._bindingCreatedTask && _this._bindingCreatedTask.stop(_this.targetElement, handlerName);
                                firstTime_2 = false;
                            }
                            else {
                                _this._bindingUpdatedTask && _this._bindingUpdatedTask.stop(_this.targetElement, handlerName);
                            }
                        }
                    });
                    if (!this._bindings) {
                        this._bindings = {};
                    }
                    this._bindings[handlerName] = bindingObserver;
                    if ($dyn.debug.general) {
                        bindingObserver.__name = "BindingEval";
                    }
                }
            };
            return Html;
        }());
        roleHandlers.Html = Html;
        /** The default role handler to use. */
        roleHandlers.Default = $dyn.roleHandlers.Html;
    })(roleHandlers = $dyn.roleHandlers || ($dyn.roleHandlers = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=RoleHandlers.js.map
